import React from 'react';
//animeJs
import anime from 'animejs';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'triangleSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('triangleSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('triangleSVG_hover');
  };
  return (
    <svg
      version="1.1"
      viewBox="0 0 155.7 140.1"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
    >
      <polygon points="18,108 72,24 126.5,108 " ref={hoverRef} />
    </svg>
  );
};

export default SVG;
